import React, { useEffect, useRef } from 'react';

/**
 * Inline, non-modal notification that lives in the page flow.
 * Auto-dismisses after `duration` ms (default 4s) or when the X is clicked.
 *
 * Usage:
 *   <InlineNotice
 *     message="Port 12C activated"
 *     kind="success" // success | info | warning | danger
 *     duration={5000}
 *     onClose={() => setNotice(null)}
 *   />
 */
const InlineNotice = ({ message, kind = 'success', duration = 4000, onClose }) => {
  const timerRef = useRef(null);

  useEffect(() => {
    if (!message) return;
    // auto-dismiss after duration
    timerRef.current = setTimeout(() => onClose?.(), duration);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [message, duration, onClose]);

  if (!message) return null;

  return (
    <div
      className={`alert alert-${kind} d-flex align-items-center justify-content-between`}
      role="alert"
      style={{ marginBottom: '10px' }}
    >
      <div className="me-3">{message}</div>
      <button
        type="button"
        aria-label="Close"
        onClick={() => onClose?.()}
        className="btn btn-sm btn-outline-secondary"
      >
        ×
      </button>
    </div>
  );
};

export default InlineNotice;
